<script>
/**
 * This mixin is a consistent, convenient way for components using
 * exhibit data to automatically load and check the status of exhibit data.
 * Several views uses this, so best to keep it in one place and load the
 * data opportunistically.
 */
export default {
    data() {
        return {
            exhibitsLoaded: false
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        loadData() {
            if (this.$store.getters.loaded) {
                this.exhibitsLoaded = true
                return
            }

            this.$store.dispatch('refreshExhibitData').then(() => {
                this.exhibitsLoaded = true
            })
        }
    },
}
</script>